import React, { useContext, useEffect, useState } from 'react';
import Title from '../../Components/Title/Title';
import { List, Row, Col, Space, Divider } from 'antd';
import { LoadScreen, Number } from 'dw-components';
import { equalTo, get, getDatabase, orderByChild, query, ref } from 'firebase/database';
import { firebaseApp } from '../../API/firebaseApp';
import { checkUserAuth, getCart } from '../../Const/SharedFunc';
import ListHeader from '../../Components/ListHeader/ListHeader';
import ListText from '../../Components/ListText/ListText';
import { useSearchParams } from 'react-router-dom';
import TitleMid from '../../Components/TitleMid/TitleMid';
import TitleGray from '../../Components/TitleGray/TitleGray';
import Lottie from 'react-lottie';
import * as animationSuccess from '../../Lottie/success.json';
import { ReactComponent as CartIcon } from '../../Svg/cartWhite.svg';
import ButtonBase from '../../Components/ButtonBase/ButtonBase';
import { CartContext } from '../../Context/CartContext';
import { useTranslation } from 'react-i18next';

const Orders = (props) => {

    const { setCart, setCartPrev } = useContext(CartContext);

    const [searchParams, setSearchParams] = useSearchParams();

    const [data, setData] = useState([]);
    const [dataOrder, setDataOrder] = useState({});
    const [loading, setLoading] = useState(false);
    const [orderId, setOrderId] = useState();
    const [userAuth, setUserAuth] = useState({});
    const { t } = useTranslation();

    const getData = async () => {

        let tUserAuth = checkUserAuth();
        let tData = [];

        if (tUserAuth?.uid) {
            setLoading(true);
            await get(query(ref(getDatabase(firebaseApp), "order"), orderByChild("uid"), equalTo(tUserAuth.uid))).then(response => {
                let resp = response.toJSON();
                if (resp) {
                    Object.keys(resp)?.map(key => {
                        let tItem = [];
                        if (resp[key].item) {
                            Object.keys(resp[key].item)?.map(itemkey => {
                                tItem.push(resp[key].item[itemkey]);
                            });
                        }
                        tData.push({ orderid: key, ...resp[key], item: tItem });
                    });
                }
            });
            setLoading(false);
        }

        tData?.sort((a, b) => {
            if (a.created > b.created) {
                return -1;
            }
            if (a.created < b.created) {
                return 1;
            }
            return 0;
        });
        setData(tData);
        setUserAuth(tUserAuth);
    }

    useEffect(() => {
        getData();
    }, []);


    const getDataOrder = async (pOrderId) => {
        if (pOrderId) {
            setLoading(true);

            let tDataOrder = {};
            await get(ref(getDatabase(firebaseApp), "order/" + pOrderId)).then(response => {
                let resp = response.toJSON();
                if (resp) {
                    let tItem = [];
                    if (resp.item) {
                        Object.keys(resp.item)?.map(itemkey => {
                            tItem.push(resp.item[itemkey]);
                        });
                    }
                    tDataOrder = { orderid: pOrderId, ...resp, item: tItem };
                }
            }).catch(() => {
                setLoading(false);
            });

            setDataOrder(tDataOrder);
            setLoading(false);
        }
    }

    useEffect(() => {
        let tOrderId = null;
        let tDataOrder = {};

        if (searchParams.get("orderid")) {
            tOrderId = searchParams.get("orderid");
            let tIndex = data?.map(r => r.orderid).indexOf(tOrderId);
            if (tIndex >= 0) {
                tDataOrder = data[tIndex];
            }
        }

        setOrderId(tOrderId);
        setDataOrder(tDataOrder);

        if (tOrderId && !tDataOrder?.refno) {
            getDataOrder(tOrderId);
        }

    }, [searchParams])


    const onOrderDtl = (pId) => {
        setSearchParams({
            orderid: pId
        });
    }

    const onCart = async () => {

        if (dataOrder?.item?.length > 0) {
            let tCart = dataOrder?.item;
            setCart(tCart);
            localStorage.setItem("cart", JSON.stringify(tCart));
            setCartPrev(true);
        }
    }

    if (loading) {
        return (
            <LoadScreen />
        );
    }

    if (orderId) {
        return (
            <div style={{ background: '#FFFFFF', border: '1px solid #DADADA', padding: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                        <TitleMid value={t("Захиалгын дугаар")} />
                        <Title value={dataOrder?.refno} />
                    </div>
                    <div>
                        <Title value={t("Захиалга бүртгэсэн")} />
                        <TitleMid value={dataOrder?.created} />
                    </div>
                </div>
                {searchParams.get("payment") && (
                    <div>
                        <div style={{ marginTop: 16, marginBottom: 32, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div>
                                <Lottie options={{
                                    loop: true,
                                    autoplay: true,
                                    animationData: animationSuccess,
                                    rendererSettings: {
                                        preserveAspectRatio: 'xMidYMid slice'
                                    }
                                }}
                                    height={160}
                                    width={160} />
                            </div>
                            <div style={{ fontWeight: 400, fontSize: 14, color: "#FFFFFF", padding: "4px 16px", background: '#FFA300', borderRadius: 14, textAlign: 'center' }}>
                                <span style={{ fontWeight: 500 }}>{t("Таны захиалга амжилттай бүртгэгдлээ.")}</span> <br /> {t("Төлбөр төлөгдсөний дараа таны захиалга баталгаажихыг анхаарна уу.")}
                            </div>
                        </div>
                        <div style={{ background: '#F9F9F9', marginTop: 16, marginBottom: 16, padding: 16 }}>
                            <TitleMid value={t("Дансаар төлөх")} />
                            <div style={{ marginTop: 16 }}>
                                <Row gutter={[16, 16]}>
                                    <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
                                        <TitleGray value={t("Дансны дугаар:")} />
                                        <div style={{ marginTop: 4 }}>
                                            <TitleMid value={t("5675562987 /ХААН/")} />
                                        </div>
                                        <div style={{ marginTop: 4 }}>
                                            <TitleMid value={t("413003681 /ХХБ/")} />
                                        </div>
                                    </Col>
                                    <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
                                        <TitleGray value={t("Хүлээн авагч:")} />
                                        <div style={{ marginTop: 4 }}>
                                            <TitleMid value={t("Тайгын шанд ХХК")} />
                                        </div>
                                    </Col>
                                    <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
                                        <TitleGray value={t("Захиалгын дүн:")} />
                                        <div style={{ marginTop: 4, display: 'flex' }}>
                                            <TitleMid value={<Number value={dataOrder?.totalprice + dataOrder?.delivery} symbol="₮" />} />
                                        </div>
                                    </Col>
                                    <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
                                        <TitleGray value={t("Гүйлгээний утга:")} />
                                        <div style={{ marginTop: 4 }}>
                                            <TitleMid value={(userAuth.phoneNumber ? userAuth.phoneNumber.substring(4) : "") + " " + dataOrder?.refno} />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                )}
                <div style={{ background: '#F9F9F9', marginTop: 16, marginBottom: 16, padding: 16 }}>
                    <TitleMid value={t("Дэлгэрэнгүй мэдээлэл")} />
                    <div style={{ marginTop: 16 }}>
                        <Row gutter={[16, 16]}>
                            <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
                                <TitleGray value={t("Бүтээгдэхүүн ашиглах газар")} />
                                <div style={{ marginTop: 4 }}>
                                    <TitleMid value={dataOrder?.regionname} />
                                </div>
                            </Col>
                            <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
                                <TitleGray value={t("Хүргэлт:")} />
                                <div style={{ marginTop: 4 }}>
                                    <TitleMid value={dataOrder?.delivery > 0 ? "Унаанд өгч явуулах" : "Салбараас очиж авах"} />
                                </div>
                            </Col>
                            <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
                                <TitleGray value={t("Утас:")} />
                                <div style={{ marginTop: 4 }}>
                                    <TitleMid value={dataOrder?.phone} />
                                </div>
                            </Col>
                            <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
                                <TitleGray value={t("И-мэйл хаяг:")} />
                                <div style={{ marginTop: 4 }}>
                                    <TitleMid value={dataOrder?.email ? dataOrder?.email : "--"} />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

                <div style={{ marginTop: 45, marginRight: 24 }}>
                    <Row style={{ width: '100%' }} gutter={[16, 16]}>
                        <Col xs={{ span: 0 }} sm={{ span: 0 }} md={{ span: 0 }} lg={{ span: 0 }} xl={{ span: 3 }} xxl={{ span: 3 }}></Col>
                        <Col xs={{ span: 10 }} sm={{ span: 10 }} md={{ span: 10 }} lg={{ span: 10 }} xl={{ span: 10 }} xxl={{ span: 10 }} >
                            <ListHeader value={t("Бүтээгдэхүүн")} />
                        </Col>
                        <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }} xxl={{ span: 3 }}>
                            <ListHeader value={t("Үнэ")} />
                        </Col>
                        <Col xs={{ span: 2 }} sm={{ span: 2 }} md={{ span: 2 }} lg={{ span: 2 }} xl={{ span: 2 }} xxl={{ span: 3 }}>
                            <div style={{ textAlign: 'right' }}>
                                <ListHeader value={t("Тоо")} />
                            </div>
                        </Col>
                        <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }} xxl={{ span: 4 }}>
                            <div style={{ textAlign: 'right' }}>
                                <ListHeader value={t("Нийт")} />
                            </div>
                        </Col>
                    </Row>
                    <Divider />
                    <List
                        itemLayout='horizontal'
                        dataSource={dataOrder?.item}
                        locale={{
                            emptyText: t("Мэдээлэл байхгүй")
                        }}
                        renderItem={(item, index) => {
                            return (
                                <List.Item>
                                    <Row gutter={[16, 16]} align='middle' style={{ width: '100%', marginTop: index == 0 ? 0 : 16, marginBottom: (index + 1 == data?.item?.length) ? 0 : 16 }}>
                                        <Col xs={{ span: 0 }} sm={{ span: 0 }} md={{ span: 0 }} lg={{ span: 0 }} xl={{ span: 3 }} xxl={{ span: 3 }}>
                                            <img style={{ width: 60, height: 60, border: '1px solid #E7E7E7' }} src={item.img} />
                                        </Col>
                                        <Col xs={{ span: 10 }} sm={{ span: 10 }} md={{ span: 10 }} lg={{ span: 10 }} xl={{ span: 10 }} xxl={{ span: 10 }}>
                                            <div className='fontMidV2' style={{ fontWeight: 400, color: '#212121' }}>
                                                {item.name} {item.producttypename && ("/" + item.producttypename + "/")}
                                            </div>
                                        </Col>
                                        <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }} xxl={{ span: 3 }}>
                                            <div className='fontMidV2' style={{ fontWeight: 400, color: '#212121' }}>
                                                <Number value={item.price} symbol="₮" />
                                            </div>
                                        </Col>
                                        <Col xs={{ span: 2 }} sm={{ span: 2 }} md={{ span: 2 }} lg={{ span: 2 }} xl={{ span: 2 }} xxl={{ span: 3 }}>
                                            <div className='fontMidV2' style={{ fontWeight: 600, color: '#212121' }}>
                                                <Number value={item.qty} />
                                            </div>
                                        </Col>
                                        <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }} xxl={{ span: 4 }}>
                                            <div className='fontMidV2' style={{ fontWeight: 600, color: '#212121' }}>
                                                <Number value={parseFloat((parseFloat(item.price) * parseInt(item.qty)).toFixed(2))} symbol="₮" />
                                            </div>
                                        </Col>
                                    </Row>
                                </List.Item>
                            );
                        }}
                    />
                    <Divider />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <ButtonBase onClick={onCart} icon={<CartIcon />} text={t("Захиалгыг дахин сагслах")} />
                    <Space>
                        <TitleMid value={t("Нийт дүн")} />
                        <Title value={<Number value={dataOrder?.totalprice} symbol="₮" />} />
                    </Space>
                </div>
            </div>
        );
    }

    return (
        <div>
            <Title value={t("Миний захиалгууд")} />
            <div>
                <List
                    itemLayout='horizontal'
                    dataSource={data}
                    locale={{
                        emptyText: t("Мэдээлэл байхгүй")
                    }}
                    renderItem={(item) => {
                        return (
                            <div
                                onClick={() => onOrderDtl(item.orderid)}
                                style={{ height: 100, background: '#FFFFFF', border: '1px solid #DADADA', padding: 16, marginTop: 24, display: 'flex', alignItems: 'center', cursor: 'pointer', boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)' }}>
                                <Row style={{ width: '100%' }} gutter={[16, 16]}>
                                    <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 5 }} xxl={{ span: 5 }} >
                                        <ListHeader value="Огноо" />
                                        <div style={{ marginTop: 4 }}>
                                            <ListText value={item.created} />
                                        </div>
                                    </Col>
                                    <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 5 }} xxl={{ span: 5 }}>
                                        <ListHeader value={t("Захиалгын дугаар")} />
                                        <div style={{ marginTop: 4 }}>
                                            <ListText value={item.refno} />
                                        </div>
                                    </Col>
                                    <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 5 }} xxl={{ span: 5 }}>
                                        <ListHeader value={t("Төлөв")} />
                                        <div style={{ marginTop: 4 }}>
                                            <ListText value={item.statusname} />
                                        </div>
                                    </Col>
                                    <Col xs={{ span: 0 }} sm={{ span: 0 }} md={{ span: 0 }} lg={{ span: 0 }} xl={{ span: 4 }} xxl={{ span: 0 }}>
                                        {item.item?.length > 0 ? (<img style={{ width: 64, height: 64, border: '1px solid #E7E7E7' }} src={item.item[0].img} />) : null}
                                    </Col>
                                    <Col xs={{ span: 0 }} sm={{ span: 0 }} md={{ span: 0 }} lg={{ span: 0 }} xl={{ span: 0 }} xxl={{ span: 4 }}>
                                        <Space>
                                            {item.item?.length > 0 ? (<img style={{ width: 64, height: 64, border: '1px solid #E7E7E7' }} src={item.item[0].img} />) : null}
                                            {item.item?.length > 1 ? (<img style={{ width: 64, height: 64, border: '1px solid #E7E7E7' }} src={item.item[1].img} />) : null}
                                            {item.item?.length > 2 ? (<img style={{ width: 64, height: 64, border: '1px solid #E7E7E7' }} src={item.item[2].img} />) : null}
                                        </Space>
                                    </Col>
                                    <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 5 }} xxl={{ span: 5 }}>
                                        <div style={{ textAlign: 'right' }}>
                                            <ListHeader value={t("Нийт дүн")} />
                                        </div>
                                        <div style={{ marginTop: 4 }}>
                                            <ListText value={<Number value={item.totalprice} symbol="₮" />} />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        );
                    }}
                />
            </div>
        </div>
    );
}

export default Orders;